// extracted by mini-css-extract-plugin
export default {"tooltip":"Gc8e264"};